import axios from '@/config/axios'


const lostFoundBase = '/v1/api/mg/bulletin/lostFound'
// 失物招领
export const lostFoundList = (query) => axios.get(`${lostFoundBase}`, {params: query})


export const createLostFound = (data) => axios.post(`${lostFoundBase}`, data)

export const updateLostFound = (data) => axios.put(`${lostFoundBase}/${data.id}`, data)

export const deleteLostFound = (id) => axios.delete(`${lostFoundBase}/${id}`)


// 新闻

const newsBase = '/v1/api/mg/bulletin/news'


export const newsList = (query) => axios.get(`${newsBase}`, {params: query})


export const createNews = (data) => axios.post(`${newsBase}`, data)

export const updateNews = (data) => axios.put(`${newsBase}/${data.id}`, data)

export const deleteNews = (id) => axios.delete(`${newsBase}/${id}`)

// 文档
const docsBase = '/v1/api/mg/docs'

export const docsList = (query) => axios.get(`${docsBase}`, {params: query})


export const createDoc = (data) => axios.post(`${docsBase}`, data)

export const updateDoc = (data) => axios.put(`${docsBase}/${data.id}`, data)

export const deleteDoc = (id) => axios.delete(`${docsBase}/${id}`)


// 日历基础

const eventsBase = '/v1/api/mg/bulletin/calendar'


export const events = (query) => axios.get(`${eventsBase}`, {params: query})


export const createEvent = (data) => axios.post(`${eventsBase}`, data)

export const updateEvent = (data) => axios.put(`${eventsBase}/${data.id}`, data)

export const deleteEvent = (id) => axios.delete(`${eventsBase}/${id}`)
